import { useGlobalForm } from '../contexts';
import type { ContentContext, ContentItem, ContentValue, RenderedContent } from '../utils';
import { resolveContent } from '../utils';

/**
 * Type de la fonction retournée par useContent
 */
export type ContentResolver = (contentItem: ContentItem, data?: Record<string, any>) => RenderedContent;

/**
 * Hook spécialisé pour la gestion du contenu contextuel
 * Retourne directement la fonction getContent pour une utilisation simple
 */
export function useContent(): ContentResolver {
  const {
    initialState: { source }, origin
  } = useGlobalForm();

  // Déterminer le contexte depuis les métadonnées du formulaire
  let context: ContentContext = (source as ContentContext) || 'site';

  // GUILLAUME: "BESOIN SPECIAL" pour avoir "Adhérent" au lieu de "Client" | Transformation pour MAE + conseiller
  if (origin === 'mae' && context === 'conseiller') {
    context = 'conseillermae';
  }

  return (contentItem: ContentItem, data?: Record<string, any>): RenderedContent => {
    // Retourner une chaîne vide si le contentItem n'existe pas
    if (!contentItem) {
      return '';
    }

    const resolvedContent: ContentValue = resolveContent(contentItem, context);

    // Si c'est une fonction (pour les contenus dynamiques)
    if (typeof resolvedContent === 'function') {
      return resolvedContent(data);
    }

    return resolvedContent as RenderedContent;
  };
}
